module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Salgesch-c7018b2a644cd4669c3b96537822d08d.svg";